import { Injectable } from '@angular/core';
import { UtilService } from './util.service';
import { AemService } from './aem.service';

@Injectable()
export class IntersectionObserverService {

    private trackedImpressions = [];
    private numOfTrackedBottomImpressions = 0;
    private numOfTrackedTopImpressions = 0;
    public constructor(private utilService: UtilService, private _aemService: AemService) { }

    /**
     *
     * @param ele element to be observed
     * @param product optional parameter for product/banner data
     */
    public createObserver(ele, product?: any, products?: any, callback? : Function): void {
        this.clearTrackedImpressions();
        
        if (['product-item-al-v1', 'product-carousel-item-al-v1', 'product-item-al-v2', 'product-carousel-item-al-v2'].includes(ele.nodeName.toLowerCase())) {
            // Configuration passed to handle intersection
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5 // Handle intersection when 50% of product/banner is visible
            };
            // Observes selector for impression ad tracking
            const intObs: IntersectionObserver = new IntersectionObserver((entries) => this.handlePCintersect(entries, product, ele, intObs), options);
            intObs.observe(ele);
        } else if (['product-carousel-al-v1'].includes(ele.nodeName.toLowerCase())) {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5 // Handle intersection when 50% of product/banner is visible
            }; 
            const intObs: IntersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting)
                        callback(ele, products)
                })
            }, options)
            // Observe the inner carousel, not the product-carousel-al-v1 directive.
            intObs.observe(ele.children[0]);
        }
    }

    public clearTrackedImpressions(){
        this.trackedImpressions = [];
        this.numOfTrackedBottomImpressions = 0;
        this.numOfTrackedTopImpressions = 0;
    }

    private handlePCintersect(entries, entity, ele, observer): void {
        // check for triggering Pacement Beacon once
        let hasFeatureProduct = false;
        entries.forEach(entry => {
            const productTracking = entity['adId'] || entity['eventTracking'];
            if (entry.isIntersecting && productTracking &&
                this.isImpressionTacked(productTracking) &&
                window['citrusAdTracker'] &&
                typeof window['citrusAdTracker'] === 'function') {

                if (['product-item-al-v1', 'product-carousel-item-al-v1', 'product-item-al-v2', 'product-carousel-item-al-v2'].includes(ele.nodeName.toLowerCase())) {
                    window['citrusAdTracker'](productTracking, 'AD_IMPRESSION');
                    hasFeatureProduct = entity.featured && entity.placementBeacons;
                    console.warn('productCard', 'AD_IMPRESSION', productTracking);
                }

                if(entity?.eventTracking?.placementType === 'top'){
                    this.numOfTrackedTopImpressions++;
                }
                if(entity?.eventTracking?.placementType === 'bottom'){
                    this.numOfTrackedBottomImpressions++;
                }
                this.trackedImpressions.push(productTracking);
                observer.unobserve(ele);
            }
        });

         // for triggering impression Placement Beacon
        if(hasFeatureProduct){
            const isGridProduct =  ['product-item-al-v2','product-item-al-v1'].includes(ele.nodeName.toLowerCase());
            const placementBeacons = entity.placementBeacons;
            
            if(isGridProduct && 
                (placementBeacons.placementOnViewBeacon_top || placementBeacons.placementOnViewBeacon_bottom)){
                if(this.numOfTrackedTopImpressions === 1){
                    window['citrusAdTracker']({
                        beacons: placementBeacons,
                        disableTracking: entity?.disableTracking
                    }, 'AD_IMPRESSION_PLACEMENT_TOP');              
                    this.numOfTrackedTopImpressions++;      
                }
                if(this.numOfTrackedBottomImpressions === 1){
                    window['citrusAdTracker']({
                        beacons: placementBeacons,
                        disableTracking: entity?.disableTracking
                    }, 'AD_IMPRESSION_PLACEMENT_BOTTOM');          
                    this.numOfTrackedBottomImpressions++;                   
                }
            } else if(this.trackedImpressions.length < 2 ){
                window['citrusAdTracker']({
                    beacons: placementBeacons,
                    disableTracking: entity?.disableTracking
                }, 'AD_IMPRESSION_PLACEMENT');
            }
        }   
    }

    /**
     *
     * @param productTracking can be ad ID or event tracking object as per V3 / new structure
     * Checks if impressions are already tracked for given adId/eventracking object
     */
    private isImpressionTacked(productTracking) {
        return !this.trackedImpressions.includes(productTracking) ||
            (typeof productTracking === 'object' && this.utilService.nativeFind(this.trackedImpressions, productTracking) === undefined ? true : false);
    }
}
